import InfoList from "../../InfoList";
import { useEffect, useState } from "react";
import { GrUserManager } from "react-icons/gr";
import { employeeById, getContactDetails } from "../../../api/employeeApi";
import LoadingSpinner from "../../LoadingSpinner";
import { getContactLabels, getNullSafeLabel } from "../../../helper";
import { Phone } from "react-feather";

const MoreInfoDriver = ({ driverId = 128 }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [driverData, setDriverData] = useState({});
  const [contactData, setContactData] = useState({});

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const driver = await employeeById(driverId);
      setDriverData(driver.employee);

      const contacts = await getContactDetails(9, driverId);
      const mainContact = contacts.find((item) => item.conType === 1);
      const contactLabels = await getContactLabels(mainContact, false);
      setContactData({ ...mainContact, ...contactLabels });
      setIsLoading(false);
    })();
  }, [driverId]);

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <InfoList
            Icon={GrUserManager}
            iconParams={{ size: 20 }}
            content={[
              {
                title: "Driver Code",
                value: getNullSafeLabel(driverData, "empCode"),
              },
              {
                title: "Full Name",
                value: getNullSafeLabel(driverData, "empFullName"),
              },
              {
                title: "Licence No",
                value: getNullSafeLabel(driverData, "empLicenceNumber"),
              },
              {
                title: "NIC Number",
                value: getNullSafeLabel(driverData, "empNic"),
              },
              {
                title: "Customer",
                value: "customerName",
              },
            ]}
            title={"Driver Info"}
            singleColumn={true}
          />
          <InfoList
            Icon={Phone}
            // iconParams={{ size: 20 }}
            content={[
              {
                title: "Email",
                value: getNullSafeLabel(contactData, "conEmail"),
              },
              {
                title: "Mobile",
                value: getNullSafeLabel(contactData, "conMobile"),
              },
              {
                title: "Address Line 1",
                value: getNullSafeLabel(contactData, "conAddress"),
              },
              {
                title: "Address Line 2",
                value: getNullSafeLabel(contactData, "conAddress2"),
              },
              {
                title: "Address Line 3",
                value: getNullSafeLabel(contactData, "conAddress3"),
              },
              {
                title: "Country",
                value: getNullSafeLabel(contactData, "conCountryValue"),
              },
              {
                title: "State",
                value: getNullSafeLabel(contactData, "conStateValue"),
              },
              {
                title: "District",
                value: getNullSafeLabel(contactData, "conDistrictValue"),
              },
              {
                title: "City",
                value: getNullSafeLabel(contactData, "conCityValue"),
              },
            ]}
            title={"Contact Info"}
            singleColumn={true}
          />
        </>
      )}
    </>
  );
};

export default MoreInfoDriver;
